export default "__VITE_ASSET__d0527a4a__"